import { useEffect, useState } from 'react';
import { useLink } from 'react-router-stack';
import Constants from '../../../constants';
import { useSelector } from 'react-redux';
import {
  Header,
  ProfileInfo,
  ProfileVerification,
  RouteWrapper,
  ScreenBackground,
  UserPlayingHistory
} from '../../../component';
import {
  getDefaultPhoneData,
  getDefaultEmailData,
  isAccountVerified
} from '../../../utilities/helper';

const Profile = () => {
  const navigate = useLink();
  const [verificationStep, setVerificationStep] = useState(0);
  const user = useSelector((state: any) => state.user);
  const {
    teamName = '',
    firstName = '',
    lastName = '',
    statuses = { ...Constants.InitialStatuses },
    phones = [],
    emails = []
  } = user;
  const defaultPhoneData = getDefaultPhoneData(phones);
  const defaultEmailData = getDefaultEmailData(emails);
  const {
    bankAccounts: bankAccountStatus,
    pan: panStatus,
    emails: emailsStatus,
    phones: phonesStatus,
    addresses: addressesStatus
  } = statuses;

  const isVerified = isAccountVerified(statuses);

  useEffect(() => {
    let verificationStep = 0;
    if (
      addressesStatus === 'verified' &&
      bankAccountStatus === 'verified' &&
      panStatus === 'verified'
    )
      verificationStep = 5;
    else if (bankAccountStatus === 'verified') verificationStep = 4;
    else if (panStatus === 'verified') verificationStep = 3;
    else if (emailsStatus === 'verified') verificationStep = 2;
    else if (phonesStatus === 'verified') verificationStep = 1;
    setVerificationStep(verificationStep);
  }, [statuses]);

  // const getPlayingSummary = () => {
  //   dispatch(
  //     getPlayingHistory({
  //       data: { userId },
  //       callback: ({ result, error }: { result: any; error: any }) => {
  //         setResultArrived(true);
  //         if (!error) {
  //           const {
  //             totalContestsWon = 0,
  //             totalContestPlayed = 0,
  //             totalMatchesPlayed: totalMatchPlayed = 0,
  //             totalWinnings = 0
  //           } = result;
  //           setTotalContestPlayed(totalContestPlayed);
  //           setTotalMatchPlayed(totalMatchPlayed);
  //           setTotalWinning(totalWinnings);
  //           setTotalContestWon(totalContestsWon);
  //         }
  //       }
  //     })
  //   );
  // };

  const onPressCompletedVerification = () => {
    navigate.push('/verify_account');
  };

  const onPressEditProfile = () => {
    navigate.push('/edit_profile', {
      PANCardStatus: panStatus
    });
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header onClickBack={onClickBack} title={'Profile'} />
        <ProfileInfo
          name={firstName != null ? `${firstName} ${lastName}`.trim() : ''}
          teamName={teamName}
          phone={defaultPhoneData['defaultPhone']}
          email={defaultEmailData['defaultEmail']}
          onPressEditProfile={onPressEditProfile}
        />
        <ProfileVerification
          onPressCompletedVerification={onPressCompletedVerification}
          verificationStep={verificationStep}
          isVerified={isVerified}
          statuses={statuses}
        />
        <UserPlayingHistory
          totalMatchPlayed={0}
          totalContestPlayed={0}
          totalContestWon={0}
          totalWinning={0}
        />
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default Profile;
